import { HttpError, isError } from "../helpers/Error"
import HttpClient from "../helpers/HttpClient"
import ProductCustomAttributeDefintion, {
    ItemCustomAttributeValues,
    ProductCustomDefinitionDto
} from "./CustomAttributeDefinition"

class CustomAttributeValueService {
    static httpClient: HttpClient<ProductCustomAttributeDefintion,
        ProductCustomDefinitionDto> = new HttpClient<ProductCustomAttributeDefintion,
        ProductCustomDefinitionDto>(ProductCustomAttributeDefintion)

    static async patch(hash: string, customAttributeValueId: string, payload: ItemCustomAttributeValues) {
        const res = await this.httpClient.patch(`/proposals/${hash}/product-custom-value/${customAttributeValueId}`, payload)
        if (isError(res)) {
            return res as HttpError
        }
        return res as ProductCustomAttributeDefintion
    }

}

export default CustomAttributeValueService


// WEBPACK FOOTER //
// ./src/state/product-custom-attributes/CustomAttributeDefinitionService.ts